import React, { useState } from "react";
import { Button, Modal, ModalBody } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteQuestionOpen, deleteSearchSuggestionRecord, getSearchSuggestionsCount,getSearchSuggestionsForCMRecords } from "../../../API/api";
import { Actions } from "../../../Action";
import styles from "./DeleteQuestionModalStyles.css";
import { handleError } from "../../../utils";
import { updateOpenTabData } from "../../../Action/actions";
import { toast } from "react-toastify";
import { CURRENT_ROLE } from "../../../API/url";
import VizButton from "../../VizButtons/VizButton";
import VizParagraph from "../../VizParagraph/VizParagraph";
import DeleteIcon from '@mui/icons-material/Delete';
import { ModalHeader } from "../../../Constants";

const onSuccessfulQuestionDelete = (message) => {
	return (
		<>
			{/* <p style={{ fontSize: "13px", fontWeight: "bold" }}>Success!</p> */}
			<span style={{ fontSize: "12px" }}>
				{message}
			</span>
		</>
	)
}

export default function DeleteQuestionModal() {
	const dispatch = useDispatch();
	const { advanceFilterModalToggle, updatePageNumberOpenTab,searchSuggestionsDataCountCM,SearchSuggestionsDataCM,getLoadingStatusForSearchSuggestions,getCheckForDeletedItems, deleteQuestionInSearchSuggestions,getDeletedItemsInSearchSuggestions,clearDeletedItemsInSearchArray,checkForDeleteAPICall } = bindActionCreators(Actions, dispatch);
	const modalState = useSelector((state) => state.domain);
	const openState = useSelector((state) => state.openQuestions);
	const searchState = useSelector((state) => state.search);
	// const [del, setDel] = useState(searchState.selectedQuestion.questionUuid);
	const searchSuggestionsReducer = useSelector((state) => state.searchSuggestionsCM);
	const state = useSelector(state=>state.cmRoot);
	const [isApiCalled, setIsApiCalled] = useState(false)


	const onClickDeleteDataConfirm = () => {
		advanceFilterModalToggle({ bool: false, value: "" })
			deleteQuestionOpen(searchState.selectedQuestion.questionUuid).then((res) => {
				if (res===undefined) return;
				if (res.success) {
					toast.success(onSuccessfulQuestionDelete(res.message), {
						position: toast.POSITION.TOP_RIGHT,
					});
				}
			}).catch((err) => {
				handleError(err)
			});		
	}

	const onClickDeleteSearchSuggestions = () => {
		let payloadForCMCount = {
			page:searchSuggestionsReducer.page,
			excludeEmail:searchSuggestionsReducer.excludeEmail,
			// domains:searchSuggestionsReducer.domainIds.toString(),
			geoLevelId:state.selecetdRoutingValue, 
			geoLevelValue:state.selectedGeoLevel.name,
			...(searchSuggestionsReducer.source === 'email') ? {excludeEmail:false} :{excludeEmail:searchSuggestionsReducer.excludeEmail},
			...(searchSuggestionsReducer.isAccepted === true && { accepted: searchSuggestionsReducer.isAccepted }),
			...(searchSuggestionsReducer.source !== '' && { source: searchSuggestionsReducer.source }),
			...(searchSuggestionsReducer.fromDate !== '' && { updatedFromDate: searchSuggestionsReducer.fromDate }),
			...(searchSuggestionsReducer.tillDate !== '' && { updatedToDate: searchSuggestionsReducer.tillDate + ` 23:59:59` }),
			...(searchSuggestionsReducer.seekers !== null && searchSuggestionsReducer.seekers.length > 0 && { seekers: searchSuggestionsReducer.seekers.toString() }),
			...(searchSuggestionsReducer.experts.length > 0 && { experts: searchSuggestionsReducer.experts.toString() }),
			...(searchSuggestionsReducer.domainIds.length > 0 ?{domains:searchSuggestionsReducer.domainIds.toString()} : { domains: state.selectedDomainIds }),
			...(searchSuggestionsReducer.isEmpty && {emptySuggestions:searchSuggestionsReducer.isEmpty}),
			...(searchSuggestionsReducer.getDislikes && {rejected:searchSuggestionsReducer.getDislikes}),
			...(searchSuggestionsReducer.genAIToggle && {genAIAnswer:searchSuggestionsReducer.genAIToggle}),
			...(searchSuggestionsReducer.bestResultToggle) && {bestResults:searchSuggestionsReducer.bestResultToggle},
			...(searchSuggestionsReducer.qSubmitted) && {submitted:searchSuggestionsReducer.qSubmitted}
		}
		let payloadForCMSearchRecords = {
			page: searchSuggestionsReducer.page,
			excludeEmail: searchSuggestionsReducer.excludeEmail,
			geoLevelId:state.selecetdRoutingValue, 
			geoLevelValue:state.selectedGeoLevel.name,
			...(searchSuggestionsReducer.source === 'email') ? {excludeEmail:false} :{excludeEmail:searchSuggestionsReducer.excludeEmail},
			...(searchSuggestionsReducer.isAccepted === true && { accepted: searchSuggestionsReducer.isAccepted }),
			...(searchSuggestionsReducer.source !== '' && { source: searchSuggestionsReducer.source }),
			...(searchSuggestionsReducer.fromDate !== '' && { updatedFromDate: searchSuggestionsReducer.fromDate }),
			...(searchSuggestionsReducer.tillDate !== '' && { updatedToDate: searchSuggestionsReducer.tillDate + ` 23:59:59` }),
			...(searchSuggestionsReducer.seekers !== null && searchSuggestionsReducer.seekers.length > 0 && { seekers: searchSuggestionsReducer.seekers.toString() }),
			...(searchSuggestionsReducer.experts.length > 0 && { experts: searchSuggestionsReducer.experts.toString() }),
			...(searchSuggestionsReducer.domainIds.length > 0 ? { domains: searchSuggestionsReducer.domainIds.toString() } : {
				domains:state.selectedDomainIds
			}),
			...(searchSuggestionsReducer.isEmpty && {emptySuggestions:searchSuggestionsReducer.isEmpty}),
			...(searchSuggestionsReducer.getDislikes && {rejected:searchSuggestionsReducer.getDislikes}),
			...(searchSuggestionsReducer.genAIToggle && {genAIAnswer:searchSuggestionsReducer.genAIToggle}),
			...(searchSuggestionsReducer.bestResultToggle) && {bestResults:searchSuggestionsReducer.bestResultToggle},
			...(searchSuggestionsReducer.qSubmitted) && {submitted:searchSuggestionsReducer.qSubmitted}
		}
		setIsApiCalled(!isApiCalled);
		checkForDeleteAPICall(true)
		deleteSearchSuggestionRecord(searchSuggestionsReducer.getQuestionUuid).then((res) => {
			if (res===undefined) return;
			clearDeletedItemsInSearchArray()
			// 		getSearchSuggestionsCount(payloadForCMCount).then((res1) => {
			// 	if (res1.data.success === true || res1.data.data !== undefined) {
			// 		searchSuggestionsDataCountCM(res1.data.data);
			// 	}
			// })
			// getSearchSuggestionsForCMRecords(payloadForCMSearchRecords
			// ).then((res2) => {
			// 	if (res2.data.data !== undefined || res2.data.success === true) {
			// 		// getCheckForDeletedItems(false);
			// 		SearchSuggestionsDataCM(res2.data.data);
			// 		getLoadingStatusForSearchSuggestions(false);
			// 		// deleteQuestionInSearchSuggestions("")
			// 	}
			// })
			if(res.success === true)
			{
			setIsApiCalled(false);
			advanceFilterModalToggle({ bool: false, value: "" })
			toast.success(onSuccessfulQuestionDelete(res.message), {
				position: toast.POSITION.TOP_RIGHT,
			});
			getSearchSuggestionsCount(payloadForCMCount).then((res1) => {
				if (res1===undefined) return;
				if (res1.data.success === true || res1.data.data !== undefined) {
					searchSuggestionsDataCountCM(res1.data.data);
				}
			})
			getSearchSuggestionsForCMRecords(payloadForCMSearchRecords
			).then((res2) => {
				if (res2===undefined) return;
				if (res2.data.data !== undefined || res2.data.success === true) {
					// getCheckForDeletedItems(false);
					checkForDeleteAPICall(false);
					SearchSuggestionsDataCM(res2.data.data);
					getLoadingStatusForSearchSuggestions(false);
				}
			})
		}
		}).catch((err) => {
			handleError(err)
		})
	}

	const onClickNo = () => {
		advanceFilterModalToggle({bool:false,value:""})
		// getCheckForDeletedItems(true)
	}

	const buttonStyles = {
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 400,
        boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
        color: 'rgb(255, 255, 255)',
        border: '1px solid rgb(255, 255, 255)',
        height: '40px',
        minWidth: '88px',
        background: 'linear-gradient(90.39deg, rgb(0, 209, 255) 0.34%, rgb(0, 117, 255) 99.7%)',
        marginBottom: '14px',
        cursor: 'pointer',
    }

	const buttonStylesCancel = {
		padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
    color: 'black',
    border: '1px solid rgb(224, 226, 230)',
    height: '40px',
    minWidth: '88px',
    background: '#f6f7f8',
    marginBottom: '14px',
	marginRight:'7px'
	}

	return (
		<Modal show={modalState.modalState}
			onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
			centered={true}
			dialogClassName={styles.deleteModal}
			size={"lg"}
			 
			>
			<Modal.Header style={CURRENT_ROLE === 'Seeker' || CURRENT_ROLE === 'Expert' ? ModalHeader.styles : null} className={(CURRENT_ROLE === 'Expert' || CURRENT_ROLE === 'Seeker') ? `` : `modalheader`} closeButton closeVariant={ (CURRENT_ROLE === 'Expert' || CURRENT_ROLE === 'Seeker') ?"" : `white`}>
				<Modal.Title>
					<DeleteIcon style={{padding:'3px',marginBottom:'2px', color: CURRENT_ROLE === 'CM' ? '#fff' : 'inherit' }} /><span style={CURRENT_ROLE === 'CM' ?{fontSize:'18px',color:'#fff'} : ModalHeader.styles}>Are you sure you want to Delete this Question?</span>
					</Modal.Title>
			</Modal.Header>
			<ModalBody className="modalBody">
				<div className="d-flex justify-content-center" style={(CURRENT_ROLE === 'Seeker' || CURRENT_ROLE === 'Expert') ? { ...ModalHeader.styles, marginBottom: "20px", marginTop: "20px" } : {marginBottom: "20px", marginTop: "20px"}}>{searchState.selectedQuestion.text}
					{
						CURRENT_ROLE === 'CM' &&
						<>
							<VizParagraph type={5} weight={1}>All of the answers and suggestions tied to this question will also be deleted
								and the Seeker will no longer be able to view this question
							</VizParagraph>
						</>
					}
				</div>
				<div className="row" style={{ marginTop: "12px", marginBottom: "12px" }}>
					<div className="col-lg-12 d-flex justify-content-center">
						{(CURRENT_ROLE !== 'CM') && 
							<>
								<button className={CURRENT_ROLE === 'Seeker' ? "" : 'deleteButton'} style={CURRENT_ROLE === 'Seeker' && buttonStylesCancel} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No</button>
								<Button style={CURRENT_ROLE === 'Seeker' && buttonStyles} className='deleteButton2' onClick={() => onClickDeleteDataConfirm()}>Yes</Button>
							</>
						}
						{CURRENT_ROLE === 'CM' && 
						isApiCalled === false &&
							<div style={{ margin: '5px' }}>
								<VizButton size={3} type={"Tertiary"} onClick={onClickNo}>No</VizButton>
							</div>
						}
						{
							CURRENT_ROLE === 'CM' && 
							isApiCalled && 
							<div style={{margin:'5px'}}>
								<VizButton size={3} type={"Disabled"}>No</VizButton>	
							</div>
						}
						{CURRENT_ROLE === 'CM'
							&& isApiCalled === false &&
							<div style={{ margin: '5px' }}>
								<VizButton size={3} type={"Primary"} onClick={onClickDeleteSearchSuggestions} >Yes</VizButton>
							</div>
						}
						{
							CURRENT_ROLE === 'CM' && 
							isApiCalled && 
							<div style={{margin:'5px'}}>
								<VizButton size={3} type={"Disabled"}>Yes</VizButton>
							</div>
						}
					</div>
				</div>
			</ModalBody>
		</Modal>
	)
}